import { Translation } from '../types';

export const no: Translation = {
  common: {
    loading: 'Laster...',
    error: 'Feil',
    cancel: 'Avbryt',
    save: 'Lagre',
    close: 'Lukk',
    search: 'Søk',
    reload: 'Last på nytt',
    logout: 'Logg ut',
    dashboard: 'Kontrollpanel',
    products: 'Produkter',
    settings: 'Innstillinger',
    language: 'Språk',
    businessHours: 'Åpningstider',
    back: 'Tilbake',
    selectAll: 'Velg alle',
    deselectAll: 'Fjern alle valg',
    success: 'Suksess',
    selected: 'Valgt',
    confirm: 'Bekreft',
    required: 'Påkrevd',
    requiredMarker: '*',
    previous: 'Forrige',
    next: 'Neste',
    allRightsReserved: 'Alle rettigheter forbeholdt.',
  },
  auth: {
    login: 'Logg inn',
    email: 'E-postadresse',
    password: 'Passord',
    loginButton: 'Logg inn',
    loggingIn: 'Logger inn...',
    loginSuccess: 'Innlogging vellykket',
    loginError: 'Feil e-post eller passord',
    invalidEmail: 'Vennligst oppgi en gyldig e-postadresse',
    requiredFields: 'Vennligst fyll ut alle påkrevde felt',
    demoAccount: 'Demokonto:',
    loginDescription: 'Oppgi kontoinformasjonen din for å logge inn',
    welcomeMessage: 'Velkommen til bedriftsbestillingssystemet',
    // Registration
    register: 'Registrer',
    createAccount: 'Opprett konto',
    confirmPassword: 'Bekreft passord',
    passwordRequirements: 'Passordet må være minst 8 tegn med store og små bokstaver, tall og spesialtegn',
    passwordsDoNotMatch: 'Passordene samsvarer ikke',
    registrationSuccess: 'Registreringen var vellykket',
    registrationDescription: 'Registrer en bedriftskonto',
    alreadyHaveAccount: 'Har du allerede en konto?',
    signIn: 'Logg inn',
    dontHaveAccount: 'Har du ikke en konto?',
    creatingAccount: 'Oppretter konto...',
    registrationNote: 'Merk:',
    registrationNotePoints: {
      erpLinking: 'Hvis du har en eksisterende bedriftskonto, vil e-posten din bli automatisk koblet',
      companyEmail: 'Vennligst bruk din bedrifts e-postadresse for registrering',
      contactSupport: 'Kontakt support hvis du trenger hjelp med registreringen'
    },
    b2bUsers: 'Bedriftskontobrukere:',
    registeredEmail: 'Registrert e-postadresse',
    registeredPassword: 'Passord satt under registrering',
    b2bCustomerRequired: 'Denne e-postadressen er ikke registrert som bedriftskunde. Vennligst kontakt salgsavdelingen for å etablere et forretningsforhold først.',
    b2bVerificationError: 'Kunne ikke verifisere bedriftskundestatus. Vennligst kontakt support.',
    // Password Reset
    passwordReset: 'Tilbakestill passord',
    passwordResetDescription: 'Oppgi e-postadressen din for å få et midlertidig passord',
    getTemporaryPassword: 'Få midlertidig passord',
    processing: 'Behandler...',
    passwordResetComplete: 'Tilbakestilling av passord fullført',
    temporaryPasswordGenerated: 'Midlertidig passord har blitt generert',
    temporaryPassword: 'Midlertidig passord',
    backToLogin: 'Tilbake til innlogging',
    securityNotice: 'Sikkerhetsmelding:',
    securityNotePoints: {
      keepSecret: 'Ikke del det midlertidige passordet med andre',
      changeAfterLogin: 'Sørg for å endre passordet ditt etter innlogging',
      expires24Hours: 'Det midlertidige passordet utløper etter 24 timer'
    },
    resetNote: 'Merk:',
    resetNotePoints: {
      registeredEmail: 'Oppgi din registrerte e-postadresse',
      passwordDisplayed: 'Det midlertidige passordet vil vises på skjermen',
      changeRequired: 'Passordbytte er påkrevd etter innlogging'
    },
    copied: 'Kopiert',
    copySuccessMessage: 'Midlertidig passord kopiert til utklippstavlen.',
    forgotPassword: 'Glemt passord?',
    // Password Reset Email Request
    sendResetLink: 'Send tilbakestillingslenke',
    sendingEmail: 'Sender e-post...',
    emailSent: 'E-post sendt',
    emailSentMessage: 'Hvis denne e-postadressen finnes i vårt system, vil du snart motta en tilbakestillingslenke.',
    emailNotSent: 'E-post ikke sendt',
    emailSentInfo: 'Sjekk innboksen og søppelpostmappen din',
    checkEmail: 'Sjekk e-post',
    emailInstructions: 'Instruksjoner for tilbakestilling av passord har blitt sendt',
    nextSteps: 'Neste steg:',
    nextStepsList: {
      checkInbox: 'Sjekk innboksen og søppelpostmappen din',
      clickLink: 'Klikk på tilbakestillingslenken i e-posten',
      linkExpires: 'Lenken utløper om 24 timer',
      contactSupport: 'Kontakt support hvis du ikke mottar e-posten',
      rateLimitInfo: 'Begrenset til 3 forespørsler per time'
    },
    // Password Reset Completion
    resetLinkSent: 'Tilbakestillingslenke sendt',
    resetSuccess: 'Passordet ble tilbakestilt',
    passwordUpdated: 'Passord oppdatert',
    passwordUpdateMessage: 'Passordet ditt har blitt oppdatert. Du kan nå logge inn med det nye passordet ditt.',
    loginWithNewPassword: 'Logg inn med nytt passord',
    // Reset Token Page
    resetToken: 'Tilbakestill passord',
    invalidToken: 'Ugyldig tilbakestillingskode',
    expiredToken: 'Tilbakestillingskoden har utløpt',
    tokenValid: 'Tilbakestillingskoden er gyldig',
    newPassword: 'Nytt passord',
    confirmNewPassword: 'Bekreft nytt passord',
    updatePassword: 'Oppdater passord',
    updatingPassword: 'Oppdaterer passord...',
    passwordMismatch: 'Passordene samsvarer ikke',
    resetInstructions: 'Oppgi ditt nye passord for å fullføre tilbakestillingen',
  },
  accountInfo: {
    title: 'Kontoinformasjon',
    loading: 'Laster kontoinformasjon...',
    error: 'Feil',
    errorMessage: 'Kunne ikke hente kontoinformasjon',
    back: 'Tilbake',
    basicInfo: 'Grunnleggende informasjon',
    name: 'Navn',
    email: 'E-postadresse',
    contactId: 'Knitido kunde-ID',
    contactNumber: 'Kontaktnummer',
    noInfo: 'Ingen informasjon',
    companyInfo: 'Bedriftsinformasjon',
    company: 'Bedriftsnavn',
    position: 'Stilling',
    vatId: 'MVA-nummer',
    billingAddress: 'Fakturaadresse',
    deliveryAddress: 'Leveringsadresse',
    addressInfo: 'Adresseinformasjon',
    billingDescription: 'Adresse for fakturaer og kontraktsdokumenter',
    deliveryDescription: 'Standard leveringsadresse for produktforsendelser',
    sameAsBilling: '※ Samme som fakturaadresse',
    sameAsDelivery: '※ Samme som leveringsadresse',
    companyName: 'Bedriftsnavn',
    contactPerson: 'Kontaktperson',
    address: 'Adresse',
    phoneNumber: 'Telefonnummer',
    billingUsage: 'Brukes til fakturaer, kontrakter og andre viktige dokumenter',
    deliveryUsage: 'Brukes som standard leveringsadresse for bestilte produkter',
    alsoUsedForDelivery: 'Brukes også som leveringsdestinasjon',
    accountType: 'Kontotype',
    addressId: 'Adresse-ID',
    // Address editing functionality
    edit: 'Rediger',
    editDeliveryAddress: 'Rediger leveringsadresse',
    editDeliveryDescription: 'Oppdater leveringsadresseinformasjonen din',
    newDeliveryAddress: 'Legg til ny leveringsadresse',
    newDeliveryDescription: 'Skriv inn detaljene for din nye leveringsadresse',
    noDeliveryAddress: 'Ingen leveringsadresse konfigurert',
    success: 'Suksess',
    addressUpdated: 'Leveringsadressen ble oppdatert',
    updateError: 'Kunne ikke oppdatere leveringsadressen',
    requiredFields: 'Vennligst fyll ut alle påkrevde felt',
    firstName: 'Fornavn',
    lastName: 'Etternavn',
    streetAddress: 'Gateadresse',
    streetAddress2: 'Gateadresse 2',
    city: 'By',
    country: 'Land',
    selectCountry: 'Velg land...',
    searchCountry: 'Søk etter land...',
    noCountryFound: 'Ingen land funnet.',
    postalCode: 'Postnummer',
    companyNamePlaceholder: 'Oppgi bedriftsnavn',
    firstNamePlaceholder: 'Fornavn',
    lastNamePlaceholder: 'Etternavn',
    streetAddressPlaceholder: 'Oppgi gateadresse',
    streetAddress2Placeholder: 'Leilighet, suite, osv.',
    cityPlaceholder: 'Oppgi by',
    postalCodePlaceholder: 'Oppgi postnummer',
    billingNotEditable: 'Fakturaadresse kan ikke redigeres.',
    billingContactSupport: 'Kontakt support for endringer.',
    // Multiple delivery addresses
    deliveryAddressCount: '{count} leveringsadresser',
    noDeliveryAddresses: 'Ingen leveringsadresser registrert',
    defaultAddress: 'Standard',
    selectDeliveryAddress: 'Velg leveringsadresse',
    addNewAddress: 'Legg til ny adresse',
    editAddress: 'Rediger adresse',
    deleteAddress: 'Slett adresse',
    confirmDelete: 'Bekreft sletting',
    confirmDeleteMessage: 'Er du sikker på at du vil slette denne adressen? Denne handlingen kan ikke angres.',
    addressAddedSuccess: 'Leveringsadresse lagt til',
    addressDeletedSuccess: 'Leveringsadresse slettet',
    deleteError: 'Kunne ikke slette leveringsadresse',
    saving: 'Lagrer...',
    cancel: 'Avbryt',
    saveChanges: 'Lagre endringer',
    selectedDeliveryAddress: 'Valgt leveringsadresse',
  },
  dashboard: {
    title: 'Forretningspartner',
    subtitle: 'Produktbestillingssystem',
    welcome: 'Velkommen,',
    welcomeMessage: 'Velkommen til forretningspartnerens bestillingssystem. Du kan bestille produkter her.',
    productCatalog: 'Produktkatalog',
    productCatalogDesc: 'Bla gjennom og bestill tilgjengelige produkter',
    viewProducts: 'Vis produkter',
    orderHistory: 'Ordrehistorikk',
    orderHistoryDesc: 'Se tidligere bestillinger',
    accountSettings: 'Kontoinnstillinger',
    accountSettingsDesc: 'Administrer kontoinformasjon',
    comingSoon: 'Kommer snart',
    infoTitle: 'Om bruk',
    orderingInfo: 'Produktbestilling',
    orderingDesc: 'Velg produkter fra katalogen og angi størrelse og farge. Lagerinformasjon er tilgjengelig i sanntid.',
    supportInfo: 'Support',
    supportDesc: 'Ta kontakt hvis du har spørsmål.',
    viewOrderHistory: 'Vis ordrehistorikk',
    viewOrders: 'Vis bestillinger',
    accountInfo: 'Kontoinformasjon',
    accountInfoDesc: 'Se kontodetaljer',
    viewDetails: 'Vis detaljer',
    supportEmail: 'b2b-partner@knitido.de',
    supportPhone: '+49(0)30 6640 9300',
    businessHours: 'Mandag-fredag 9:00 - 15:00 CET',
    bulkImportDesc: 'Importer bestillinger fra Excel/CSV-filer',
    importOrders: 'Importer bestillinger',
  },
  products: {
    title: 'Produktliste',
    subtitle: 'Forretningspartner',
    searchPlaceholder: 'Søk etter produktnavn eller SKU...',
    productId: 'Produkt-ID',
    addToCart: 'Legg i handlekurv',
    selectVariation: 'Velg variant',
    price: 'Pris',
    priceNetNotice: 'Alle priser er uten MVA',
    stock: 'Lager',
    color: 'Farge',
    newProducts: 'Nye Produkter',
    newProductBadge: 'NY',
    size: 'Størrelse',
    quantity: 'Antall',
    total: 'Totalt',
    cart: 'Handlekurv',
    checkout: 'Til kassen',
    csvMode: 'CSV hurtigmodus',
    csvInfo: 'Produktdata hentet fra CSV-data',
    csvUploadDate: 'CSV-opplastingsdato:',
    stockNote: '※ Lagerinformasjon hentes når produktvarianter velges',
    noProducts: 'Ingen produkter funnet',
    noProductsDesc: 'Endre søkekriterier eller last opp en CSV-fil for raskere ytelse.',
    retry: 'Prøv igjen',
    pagination: 'elementer',
    variations: 'varianter',
    stockFetchError: 'Lagerhentingsfeil',
    stockFetchFailed: 'Lagerhenting mislyktes',
    stockFetchFailedDesc: 'Kunne ikke hente lagerinformasjon. CSV-lager vil bli vist.',
    stockFetched: 'Lagerinformasjon hentet',
    totalStock: 'Totalt lager',
    noStockAll: 'Alle varianter har null på lager',
    noStockData: 'Ingen lagerdata returnert',
    stockFetchErrorDesc: 'Feil oppstod under henting av lagerinformasjon',
    selectionError: 'Valgfeil',
    enterQuantity: 'Vennligst oppgi antall',
    addedToCart: 'Lagt til i handlekurven',
    typesAdded: ' produkttyper lagt til',
    addToCartError: 'Feil ved tillegg i handlekurv',
    addToCartErrorDesc: 'Vennligst prøv igjen',
    loadingStock: 'Laster lagerinformasjon',
    csvDataInfo: 'Viser CSV-datainformasjon (ikke faktiske lagernivåer)',
    invalidDataFormat: 'Produktdataformatet er ugyldig',
    loadFailed: 'Kunne ikke laste produktdata',
    csvUploadComplete: 'CSV-opplasting fullført',
    csvLoadedDesc: ' produktdata lastet. Lagerinformasjon vil bli hentet når du velger produkter.',
    searchTitle: 'Produktsøk',
    loadingProducts: 'Laster produktdata',
    noProductsCsv: 'Ingen produkter funnet i CSV-data. Vennligst endre søkekriterier.',
    paginationDisplay: ' vist',
    previous: 'Forrige',
    next: 'Neste',
    selectionSummary: 'Valgsammendrag',
    selectedQuantity: 'Valgt mengde',
    items: ' elementer',
    viewDetails: 'Vis detaljer',
    productImage: 'Produktbilde',
    correspondingVariations: 'Tilsvarende varianter',
    clickToEnlarge: 'Klikk for å forstørre',
    productIdLabel: 'Produkt-ID',
    colorLabel: 'Farge',
    filterByCategory: 'Filtrer etter kategori',
    allProducts: 'Alle produkter',
    applyFilters: 'Bruk filtre',
    clearFilters: 'Tøm filtre',
    filters: 'Filtre',
    clearAll: 'Tøm alt',
  },
  categories: {
    category_21: 'Tåsokker',
    category_23: 'Ukategorisert',
    category_24: 'Kroppsplagg',
    category_29: 'B2B-produkter',
  },
  productDetail: {
    title: 'Produktdetaljer',
    backToProducts: 'Tilbake til produkter',
    productNotFound: 'Produkt ikke funnet',
    productNotFoundDesc: 'Det angitte produktet eksisterer ikke eller har blitt slettet.',
    loading: 'Laster produkt...',
    imageLoadError: 'Kunne ikke laste bilder',
    noImages: 'Ingen bilder tilgjengelig',
    productDescription: 'Produktbeskrivelse',
    colors: 'Farger',
    sizes: 'Størrelser',
    colorCount: 'farger',
    sizeCount: 'størrelser',
    variationCount: 'varianter',
    selectVariation: 'Velg varianter',
    descriptionLanguageNote: '※ Produktbeskrivelser er kun tilgjengelig på engelsk eller tysk',
  },
  colors: {
    schwarz: 'Svart',
    weiß: 'Hvit',
    grau: 'Grå',
    rot: 'Rød',
    blau: 'Blå',
    grün: 'Grønn',
    gelb: 'Gul',
    rosa: 'Rosa',
    lila: 'Lilla',
    braun: 'Brun',
    orange: 'Oransje',
    beige: 'Beige',
    navy: 'Marineblå',
    dunkelblau: 'Mørkeblå',
    hellblau: 'Lyseblå',
    dunkelgrau: 'Mørkegrå',
    hellgrau: 'Lysegrå',
    bordeaux: 'Bordeaux',
    türkis: 'Turkis',
    khaki: 'Khaki',
    mint: 'Mynte',
    violett: 'Fiolett',
    anthrazit: 'Antrasitt',
    blaugrau: 'Blågrå',
    burgunderrot: 'Burgunder',
    elfenbein: 'Elfenben',
    karminrot: 'Karminrød',
    neongrün: 'Neongrønn',
    gelbgrün: 'Gulgrønn',
    pistazie: 'Pistasj',
    // Engelske fargenavn (brukt i Product ID 237, osv.)
    blue: 'Blå',
    ivory: 'Elfenben',
    green: 'Grønn',
    gold: 'Gull',
    red: 'Rød',
  },
  checkout: {
    title: 'Kassen',
    cartReview: 'Ordreoversikt',
    orderSummary: 'Ordresammendrag',
    shippingInfo: 'Leveringsinformasjon',
    billingInfo: 'Faktureringsinformasjon',
    orderNotes: 'Ordrenotater',
    orderNotesPlaceholder: 'Spesielle forespørsler eller notater...',
    contactPerson: 'Kontaktperson',
    phoneNumber: 'Telefonnummer',
    email: 'E-postadresse',
    company: 'Bedrift',
    address: 'Adresse',
    city: 'By',
    postalCode: 'Postnummer',
    country: 'Land',
    deliveryDate: 'Leveringsdato',
    urgentDelivery: 'Ekspresslevering (3-5 virkedager)',
    standardDelivery: 'Standardlevering (7-10 virkedager)',
    placeOrder: 'Send bestilling',
    backToCart: 'Tilbake til produktvalg',
    requiredField: 'Påkrevd felt',
    orderTotal: 'Ordretotal',
    subtotal: 'Delsum',
    priceNetNotice: 'Alle priser er uten MVA',
    stockReservationNotice: 'Lagerreservasjon vil bli gjort etter ordrebekreftelse.',
    stockCheckError: 'Lagersjekk-feil',
    stockCheckErrorDesc: 'Feil oppstod under lagersjekk. Vennligst prøv igjen.',
    shipping: 'Frakt',
    shippingCost: 'Fraktkostnad',
    tax: 'MVA',
    orderSuccess: 'Bestilling vellykket',
    orderSuccessMessage: 'Din bestilling er sendt. Ordrenummer: {orderNumber}',
    orderNumber: 'Ordrenummer',
    thankYou: 'Takk for din bestilling!',
    orderConfirmation: 'Din bestilling er sendt.',
    orderProcessing: 'Etter gjennomgang fra vårt team vil vi sende deg en ordrebekreftelse via e-post.',
    orderProcessingMessage: 'Din bestilling er sendt. Etter gjennomgang fra vårt team vil vi sende deg en ordrebekreftelse via e-post.',
    continueShopping: 'Fortsett shopping',
    emptyCart: 'Handlekurven din er tom',
    emptyCartMessage: 'Vennligst legg til produkter i handlekurven for å fortsette',
    stockWarning: 'Lageradvarsel',
    stockWarningDesc: 'Noen varer har utilstrekkelig lager. Vennligst juster mengder.',
    stockError: 'Lagerfeil',
    stockErrorDesc: 'Det er varer med utilstrekkelig lager. Vennligst juster mengder.',
    refreshStock: 'Oppdater lager',
    stockUpdated: 'Lager oppdatert',
    stockUpdatedDesc: 'Lager har blitt oppdatert - {changed} varer endret',
    stockCheckDesc: 'Sammenligningsresultater med beholdning vises',
    stockOk: 'Lager OK',
    stockShortage: 'Lagermangel',
    requestedQty: 'Forespurt mengde',
    currentStock: 'Nåværende lager',
    stockShortageMsg: 'Utilstrekkelig lager. Vennligst juster mengden.',
    stockIssueWarning: 'Ordre kan ikke bekreftes på grunn av lagerproblemer.',
    stockDataMissing: 'Lagerdata hentes. Vennligst vent et øyeblikk.',
    outOfStock: 'Utsolgt.',
    maxAvailable: 'Maksimum',
    autoRestored: 'Handlevogn gjenopprettet',
    autoRestoredDesc: 'Varer fra forrige økt er gjenopprettet',
    maxQuantityReached: 'Maksimal lagermengde nådd.',
    // ERP Contact Search
    contactSearch: 'Kundekontaktsøk',
    contactSearchDesc: 'Oppgi bestillerens e-postadresse for å hente kontaktinformasjon',
    emailAddress: 'E-postadresse',
    searchButton: 'Søk',
    searching: 'Søker',
    contactFound: 'Kontakt funnet',
    contactNotFound: 'Kontakt ikke funnet',
    contactId: 'Knitido kunde-ID',
    companyName: 'Bedrift',
    contactPersonLabel: 'Kontaktperson',
    addressesFound: 'Adresser funnet',
    addressType: 'Type',
    addressBilling: 'Fakturaadresse',
    addressDelivery: 'Leveringsadresse',
    vatSourceCompany: 'Bedriftsinfo',
    vatSourceBilling: 'Faktura',
    vatSourceDelivery: 'Levering',
    addressOther: 'Annet',
    addressDetails: 'Adresse',
    loadingAddresses: 'Laster adresseinformasjon...',
    addressRetrieved: 'Adresseinformasjon hentet',
    addressNotFound: 'Adresseinformasjon ikke funnet',
    addressNotFoundDesc: 'Ingen registrert adresseinformasjon. Vennligst oppgi manuelt.',
    addressError: 'Adressehentingsfeil',
    addressErrorDesc: 'Kunne ikke hente adresseinformasjon.',
    contactNotConfirmed: 'Kundekontakt ikke bekreftet',
    contactNotConfirmedDesc: 'Vennligst oppgi en e-postadresse og søk etter kontakten.',
    searchContact: 'Søk kontakt',
    inputError: 'Inndatafeil',
    inputErrorDesc: 'Leveringsinformasjon er ufullstendig. Vennligst sjekk.',
    processing: 'Behandler...',
    erpContactSearch: 'Kundekontaktsøk',
    contactSearchError: 'E-postadressen samsvarer ikke med noen registrert kontakt.',
    // Product Images Toggle
    showProductImages: 'Vis produktbilder',
    showProductImagesDesc: 'Vis produktbilder for bedre oversikt (kan øke lastetiden)',
    // System Registration Info
    systemRegistrationInfo: 'Din kundeinformasjon',
    editShippingAddress: 'Rediger leveringsadresse',
    systemRegistrationInfoDesc: 'Din registrerte bedriftsinformasjon. Vennligst kontakt din representant hvis du trenger å oppdatere faktureringsadressedetaljer.',
    // Order Summary
    regularPrice: 'Ordinær engrospris',
    offeredPrice: 'Tilbudt pris',
    discount: 'Rabatt',
    b2bCustomer: 'B2B-kunde',
    pattern: 'Mønster',
    specialPriceApplied: 'Spesialpris brukt',
    customerClassification: 'Kundeklassifisering',
    paymentCondition: 'Betalingsbetingelser',
    invoice: 'Faktura (NETTO 30)',
    prepayment: 'Forskuddsbetaling',
    paymentMethod: 'Betalingsmetode',
    invoicePayment: 'Fakturabetaling',
    estimatedSubtotal: 'Estimert delsum',
    estimatedTotal: 'Estimert totalsum',
    orderSummaryDisclaimer: 'Prisene som vises her er estimater. Når vi mottar din bestilling, vil vi gjennomgå den og sende deg en bindende ordrebekreftelse med endelige priser, fraktkostnader og avgifter via e-post.',
    searchError: 'Søkefeil',
    searchErrorDesc: 'En feil oppstod under kontaktsøk.',
    confirmDeleteItem: 'Fjern vare',
    itemDeleted: 'Vare fjernet',
    confirmDeleteItemDesc: 'Er du sikker på at du vil fjerne følgende vare fra handlekurven?',
    deleteConfirm: 'Fjern',
    contactNotes: 'Kontaktnotater',
    contactNotesDesc: 'Har du spørsmål eller spesielle forespørsler? Gi oss beskjed (valgfritt)',
    contactNotesLabel: 'Melding',
    contactNotesPlaceholder: 'f.eks.: Produktspørsmål, spesielle krav osv.',
    characters: 'tegn',
    contactIdLabel: 'Knitido kunde-ID',
    companyLabel: 'Bedrift',
    personLabel: 'Kontaktperson',
    emailLabel: 'E-post',
    addressTypeLabel: 'Type',
    destinationLabel: 'Destinasjon',
    // Shipping Form
    shippingTitle: 'Leveringsinformasjon',
    shippingDesc: 'Oppgi leveringsadressen for produktene',
    companyRequired: 'Bedrift *',
    contactPersonRequired: 'Kontaktperson *',
    emailRequired: 'E-postadresse *',
    phoneRequired: 'Telefonnummer *',
    addressRequired: 'Adresse 1 *',
    address2: 'Adresse 2 (Bygning/Rom)',
    postalCodeRequired: 'Postnummer *',
    cityRequired: 'By *',
    countryRequired: 'Land *',
    selectCountry: 'Velg land',
    shippingMethodRequired: 'Leveringsmetode *',
    selectShippingMethod: 'Velg leveringsmetode',
    urgentDeliveryOption: 'Ekspresslevering (tilleggskostnader)',
    deliveryNotes: 'Leveringsnotater',
    deliveryNotesPlaceholder: 'Oppgi leveringstidspreferanser eller andre forespørsler',
    standardShipping: 'Standardfrakt (3-5 virkedager)',
    expressShipping: 'Ekspressfrakt (1-2 virkedager)',
    overnightShipping: 'Leveranse over natten',
    germany: 'Tyskland',
    austria: 'Østerrike',
    switzerland: 'Sveits',
    japan: 'Japan',
    shippingAddressLabel: 'Leveringsadresse',
    changeDeliveryAddress: 'Endre leveringsadresse',
    selectDeliveryAddress: 'Velg leveringsadresse',
    // Shipping Cost Details
    freeShipping: 'Gratis frakt',
    shippingError: 'Feil',
    shippingZone: 'Fraktsone',
    remainingForFreeShipping: '{amount} igjen for gratis frakt',
    moreForFreeShipping: 'mer for gratis frakt',
    freeShippingProgress: 'Gratis frakt ved',
    andAboveFreeShipping: 'og oppover for gratis frakt',
    freeShippingAchieved: 'Gratis frakt brukt',
    threshold: 'og oppover',
    nextShippingTier: 'Neste fraktrabatt',
    moreForDiscount: 'mer for',
    shippingSavings: 'fraktbesparelser',
    orderAmountThreshold: 'og oppover for',
    specialRegionNotice: 'Spesial fraktsone brukt',
    defaultShippingApplied: 'Standard fraktpriser brukt',
    requestedQuantity: 'Forespurt mengde',
    availableQuantity: 'Tilgjengelig mengde',
    orderSubmitError: 'Feil ved ordreinnlevering',
    orderSubmitErrorDesc: 'Kunne ikke sende inn bestillingen',
    upload: {
      title: 'Importer Excel/CSV-bestilling',
      description: 'Last opp en Excel- eller CSV-fil med dine bestillingsdata',
      dragDropOrClick: 'Dra og slipp fil her eller klikk for å velge',
      dropHere: 'Slipp fil her',
      supportedFormats: 'Støttede formater: Excel (.xlsx, .xls) og CSV (.csv)',
      maxSize: 'Maksimal filstørrelse: {size} MB',
      processFile: 'Behandle fil',
      processing: 'Behandler fil...',
      ready: 'Fil klar for forhåndsvisning',
      readyDescription: 'Filen din har blitt behandlet og er klar for gjennomgang.',
      preview: 'Vis forhåndsvisning',
      errors: {
        fileTooLarge: 'Filen er for stor. Maksimal størrelse: {size} MB',
        invalidFileType: 'Ugyldig filtype. Vennligst last opp en Excel- eller CSV-fil',
        uploadFailed: 'Feil ved opplasting av fil',
      },
    },
    // Loading messages
    loadingPage: 'Laster side...',
    loadingStock: 'Sjekker produktlager...',
    loadingAccount: 'Laster kontoinformasjon...',
    loadingError: 'En feil oppstod...',
    loadingData: 'Laster data',
    // Toast messages
    addressRetrievedTitle: 'Adresseinformasjon hentet',
    addressSetAsDelivery: ' adresse satt som leveringsdestinasjon.',
    contactFoundDesc: ' ble gjenkjent.'
  },
  orderHistory: {
    title: 'Ordrehistorikk',
    searchPlaceholder: 'Søk etter ordrenummer eller SKU...',
    noOrders: 'Ingen bestillinger funnet',
    noOrdersFound: 'Ingen samsvarende bestillinger funnet',
    startShopping: 'Vis produkter',
    orderItems: 'Ordrevarer',
    viewDetails: 'Detaljer',
    reorder: 'Bestill på nytt',
    orderDate: 'Ordredato',
    orderStatus: 'Status',
    orderTotal: 'Ordretotal',
    // Status translations
    statusPending: 'Venter på betaling',
    statusProcessing: 'Behandler',
    statusConfirmed: 'Bekreftet',
    statusShipped: 'Sendt',
    statusDelivered: 'Levert',
    statusCancelled: 'Kansellert',
    statusReturned: 'Returnert',
    statusRefunded: 'Refundert',
    statusWarranty: 'Garanti',
    statusExchanged: 'Byttet',
    statusRepair: 'Reparasjon',
    statusUnknown: 'Ukjent',
    statusIncomplete: 'Ufullstendig',
    statusWaitingPayment: 'Venter på betaling',
    statusInPreparation: 'Under forberedelse',
    statusClearedShipping: 'Klar for frakt',
    statusBeingShipped: 'Sendes',
    statusOutgoingBooked: 'Utgående bestilt',
    statusReturn: 'Retur',
    // Additional UI elements
    itemCount: 'varer',
    itemCountSingular: 'vare',
    refreshButton: 'Oppdater',
    errorFetchingOrders: 'Kunne ikke hente ordrehistorikk',
    // Payment status features
    paymentStatus: 'Betalingsstatus',
    markAsPaid: 'Merk som betalt',
    unmarkAsPaid: 'Fjern betalingsmerke',
    paidOn: 'Betalt',
    paymentMarked: 'Betalt',
    notPaid: 'Ikke betalt',
    paymentMarkedSuccess: 'Vellykket merket som betalt',
    paymentUnmarkedSuccess: 'Betalingsmerke fjernet',
    paymentUpdateError: 'Kunne ikke oppdatere betalingsstatus',
    // Payment date dialog
    paymentDateTitle: 'Oppgi betalingsinformasjon',
    paymentDateDescription: 'Oppgi betalingsinformasjon for ordre {orderNumber}',
    paymentDateLabel: 'Betalingsdato',
    selectDate: 'Velg dato',
    paymentDateHelp: 'Velg datoen da bankoverføringen ble gjort',
    paymentMethodLabel: 'Betalingsmetode',
    bankTransfer: 'Bankoverføring',
    invoice: 'Faktura',
    otherPayment: 'Annet',
    paymentReferenceLabel: 'Overføringsnavn / Referansenummer',
    paymentReferencePlaceholder: 'f.eks. Ola Nordmann, Overføring #12345',
    paymentReferenceHelp: 'Oppgi informasjon som hjelper å matche med kontoutskrifter',
    notesLabel: 'Notater',
    notesPlaceholder: 'Oppgi eventuell tilleggsinformasjon om betalingen',
    // Filter options
    filterByPaymentStatus: 'Filtrer etter betalingsstatus',
    allOrders: 'Alle bestillinger',
    paidOrders: 'Betalte',
    unpaidOrders: 'Ubetalte',
    // Sorting options
    sortBy: 'Sorter etter',
    sortByDate: 'Ordredato',
    sortByPaymentDate: 'Betalingsdato',
    sortByAmount: 'Beløp',
    sortByStatus: 'Status',
  },
  orderDetails: {
    title: 'Ordredetaljer',
    notFound: 'Ordre ikke funnet',
    backToHistory: 'Tilbake til ordrehistorikk',
    orderDate: 'Ordredato',
    orderItems: 'Ordrevarer',
    deliveryStatus: 'Leveringsstatus',
    estimatedDelivery: 'Estimert levering',
    deliveredOn: 'Levert',
    downloadInvoice: 'Last ned faktura',
    statusDelivered: 'Levert',
    statusShipped: 'Sendt',
    statusConfirmed: 'Bekreftet',
    statusCancelled: 'Kansellert',
    errorFetchingDetails: 'Kunne ikke hente ordredetaljer',
  },
  company: {
    name: 'Forretningspartner',
    tagline: 'Forretningspartnersystem',
    copyright: '© 2025 Forretningspartnersystem. Alle rettigheter forbeholdt.',
  },
  footer: {
    phone: 'Telefon',
    email: 'E-post',
    countries: {
      DE: 'Tyskland',
      AT: 'Østerrike',
      CH: 'Sveits',
      FR: 'Frankrike',
      IT: 'Italia',
      ES: 'Spania',
      NL: 'Nederland',
      BE: 'Belgia',
      PL: 'Polen',
      SE: 'Sverige',
      NO: 'Norge',
      FI: 'Finland',
      DK: 'Danmark',
      LT: 'Litauen',
      LV: 'Latvia',
      EE: 'Estland',
    },
  },
  cart: {
    newCart: 'Ny handlekurv',
    currentCart: 'Nåværende handlekurv',
    modified: 'endret',
    lastSaved: 'Sist lagret',
    unsavedChanges: 'ulagrede endringer',
    saveCart: 'Lagre handlekurv',
    loadCart: 'Last handlekurv',
    deleteCart: 'Slett handlekurv',
    startNewCart: 'Start ny handlekurv',
    savedCarts: 'Lagrede handlekurver',
    cartSaved: 'Handlekurv lagret',
    cartDeleted: 'Handlekurv slettet',
    confirmDeleteCart: 'Slett handlekurv?\n\nDenne handlingen kan ikke angres.',
    confirmSwitchCart: 'Den nåværende handlekurven har ulagrede endringer.\n\nÅ laste en annen handlekurv vil miste de nåværende endringene.\n\nFortsett?',
    confirmSwitchCartTitle: 'Bytt handlekurv',
    confirmNewCart: 'Den nåværende handlekurven har ulagrede endringer.\n\nÅ starte en ny handlekurv vil miste de nåværende endringene.\n\nFortsett?',
    confirmNewCartTitle: 'Start ny handlekurv',
    confirmClearCart: 'Tøm handlekurv?\n\n{count} varer vil bli fjernet.\n\nDenne handlingen kan ikke angres.',
    confirmClearCartTitle: 'Tøm handlekurv',
    autoSaved: 'Autolagret',
    itemsWillBeRemoved: 'varer vil bli fjernet',
    changesWillBeLost: 'endringer vil gå tapt',
    continueQuestion: 'Fortsett?',
    cartStatus: 'Handlekurvstatus',
    cartName: 'Handlekurvnavn',
    cartNamePlaceholder: 'f.eks.: Månedssluttbestilling',
    cartNameRequired: 'Vennligst oppgi et handlekurvnavn',
    saveCartDescription: 'Gi den nåværende handlekurven et navn og lagre den. Du kan laste den senere.',
    cancelCart: 'Avbryt handlekurv',
    proceedToCheckout: 'Gå til kassen',
    emptyCart: 'Handlekurven er tom',
    erpDown: 'Bestillingssystemet er nede. Vennligst prøv igjen senere.',
    erpDegraded: 'Systemet er for øyeblikket ustabilt. Bestillinger kan mislykkes.',
    erpDownSaveHint: 'Lagre handlekurven din og bestill når systemet er gjenopprettet.',
    erpSaveCart: 'Lagre handlekurv',
  },
  nav: {
    dashboard: 'Kontrollpanel',
    products: 'Produkter',
    orderHistory: 'Bestillinger',
    account: 'Kontoinformasjon',
    bulkImport: 'Masseimport',
  },
  settings: {
    selectLanguage: 'Velg et språk',
    languagePreferenceSaved: 'Ditt valg vil bli lagret på kontoen din for fremtidige besøk.',
  },
  reorder: {
    allItemsAdded: '{count} varer lagt til i handlekurven',
    partialSuccess: '{added} varer lagt til. {failed} varer kunne ikke legges til',
    allItemsFailed: 'Kunne ikke legge til varer i handlekurven',
    error: 'En feil oppstod under nybestilling',
    itemDiscontinued: '{name} ({color}/{size}) har blitt avviklet',
    itemOutOfStock: '{name} ({color}/{size}) er utsolgt',
    partialStock: '{name} ({color}/{size}) kun {available} tilgjengelig',
    confirmReorder: 'Bekreft nybestilling',
    confirmReorderMessage: 'Legg til varer fra denne bestillingen i handlekurven?',
    addingToCart: 'Legger til i handlekurv...',
    checkingStock: 'Sjekker lager...',
    checkoutTitle: 'Varer lagt til i handlekurv',
    checkoutDescription: '{count} varer har blitt lagt til i handlekurven din. Ønsker du å gå til kassen?',
  },
  bulkImport: {
    instructions: 'Slik importerer du bestillinger',
    step1: 'Last ned ordremalsfilen',
    step2: 'Fyll inn bestillingsdataene dine med SKU og mengde',
    step3: 'Lagre som Excel (.xlsx) eller CSV-fil',
    step4: 'Last opp filen ved hjelp av skjemaet nedenfor',
    step5: 'Gjennomgå og bekreft bestillingen din',
    downloadTemplate: 'Last ned mal',
    downloadExcelTemplate: 'Last ned Excel-mal',
    downloadCsvTemplate: 'Last ned CSV-mal',
    formatGuide: 'Filformatveiledning',
    requiredColumns: 'Påkrevde kolonner',
    skuDescription: 'Produkt-SKU-kode',
    quantityDescription: 'Bestillingsmengde (positivt heltall)',
    optionalColumns: 'Valgfrie kolonner',
    notesDescription: 'Interne notater (f.eks. PO-nummer, referanse) - kun for dine poster',
    formatNote: 'Første rad skal inneholde kolonneoverskrifter. Data starter fra andre rad.',
    parseSuccess: 'Vellykket behandlet {count} varer fra filen',
    parseError: 'Behandlingsfeil',
    validationError: 'Valideringsfeil',
    validationErrorGuidance: 'Vennligst klikk på "{showPreviewButton}"-knappen for å gjennomgå detaljene.',
    warnings: 'Advarsler',
    itemsParsed: 'Vellykket behandlet {count} varer:',
    andMore: '...og {count} flere varer',
    validationSummary: 'Valideringssammendrag',
    duplicateSKUs: 'Dupliserte SKU-er funnet',
    skuFormat: 'SKU må kun inneholde bokstaver, tall og bindestreker',
    quantityRange: 'Mengde må være mellom 1 og 9999',
    maxRows: 'Maksimalt 1000 rader tillatt',
    rowsSkipped: '{count} rader ble hoppet over på grunn av feil',
    previewTitle: 'Ordreforhåndsvisning',
    previewDescription: 'Gjennomgå og rediger bestillingsdataene dine før du fortsetter',
    proceedToCart: 'Legg til i handlekurv',
    // File parsing messages
    fileEmpty: 'Filen er tom eller inneholder ingen data',
    fileTooManyRows: 'Filen inneholder for mange rader ({current}). Maksimalt tillatt: {max}',
    invalidRowFormat: 'Ugyldig radformat',
    missingColumns: 'Mangler påkrevde kolonner (SKU og Mengde)',
    missingSku: 'Mangler SKU',
    invalidSkuFormat: 'Ugyldig SKU-format: "{sku}" (må samsvare med mønster: {pattern})',
    skuTooLong: 'SKU for lang: "{sku}" (maksimalt 50 tegn)',
    invalidQuantity: 'Ugyldig mengde: "{quantity}" er ikke et tall',
    quantityTooLow: 'Mengde for lav: {quantity} (minimum: {min})',
    quantityTooHigh: 'Mengde for høy: {quantity} (maksimum: {max})',
    notesRequired: 'Notatfelt påkrevd',
    noValidData: 'Ingen gyldige data funnet. Vennligst sjekk filformatet ditt.',
    row: 'Rad {row}: {errors}',
    rowErrors: '...og {count} flere feil',
    duplicateSkuInRows: 'Duplisert SKU "{sku}" funnet i rader: {rows}',
    quantityExceedsMax: 'Rad {row}: Mengde {quantity} overskrider maksimalt tillatt ({max})',
    quantityBelowMin: 'Rad {row}: Mengde {quantity} er under minimum påkrevd ({min})',
    // Validation messages
    unsupportedFileFormat: 'Ustøttet filformat. Vennligst last opp en CSV- eller Excel-fil.',
    csvParsingErrors: 'CSV-behandlingsfeil oppstod',
    failedToParseFile: 'Kunne ikke behandle fil',
    failedToParseExcel: 'Kunne ikke behandle Excel-fil',
    failedToReadFile: 'Kunne ikke lese fil',
    unknownError: 'Ukjent feil oppstod',
    totalRows: 'Totalt rader',
    valid: 'Gyldige',
    invalid: 'Ugyldige',
    skipped: 'Hoppet over',
    // SKU validation
    skuValidationError: 'SKU-valideringsfeil',
    skuValidationFailed: 'Kunne ikke validere SKU-er. Du kan fortsatt fortsette, men noen varer er kanskje ikke tilgjengelige.',
    skuNotFound: 'SKU ikke funnet i databasen',
    skusNotFound: '{count} SKU-er ikke funnet i databasen',
    itemsHaveInsufficientStock: '{count} varer har utilstrekkelig lager',
    validatingSKUs: 'Validerer varer...',
    unvalidatedChanges: 'Du har uvaliderte endringer. Vennligst valider på nytt før du legger til i handlekurven.',
    revalidate: 'Valider på nytt',
    validating: 'Validerer...',
    validationSuccess: 'Alle varer er gyldige',
    validationComplete: 'Validering fullført',
    validationResultSummary: '{errors} feil, {warnings} advarsler funnet',
    // Table headers
    actions: 'Handlinger',
    notes: 'Notater',
    // Status filter
    all: 'Alle',
    hasErrors: 'Har feil',
    // Selection summary
    selected: 'valgt',
    errors: 'feil',
    // Pagination
    page: 'Side {current} av {total}',
    previous: 'Forrige',
    next: 'Neste',
    noResults: 'Ingen resultater.',
    // Cart integration
    noValidItems: 'Ingen gyldige varer',
    allItemsHaveErrors: 'Alle varer har valideringsfeil. Vennligst rett dem før du fortsetter.',
    dataLoadingError: 'Datainnlastingsfeil',
    failedToLoadProductData: 'Kunne ikke laste produktdata. Vennligst prøv igjen.',
    itemsAddedToCart: '{count} varer lagt til i handlekurv',
    itemsAddedMessage: 'La til {count} varer i handlekurven',
    someSkusNotFound: '{count} SKU-er kunne ikke finnes.',
    noItemsAdded: 'Ingen varer lagt til',
    couldNotFindProducts: 'Kunne ikke finne noen produkter som samsvarer med SKU-ene.',
    errorAddingToCart: 'Feil',
    failedToAddToCart: 'Kunne ikke legge til varer i handlekurven. Vennligst prøv igjen.',
    addingToCart: 'Legger til i handlekurv...',
    // File info
    fileSelected: '{name} valgt for behandling',
    fileSize: '{size} bytes',
    fileSizeKB: '{size} KB',
    fileSizeMB: '{size} MB',
    // Template download
    templateDownload: 'Malnedlasting',
    templateWillBeImplemented: 'Malnedlasting vil bli implementert i fase 7',
    // Additional validation
    validationFailed: 'Validering mislyktes',
    // Template download
    templateDownloaded: 'Mal lastet ned vellykket',
    templateDownloadError: 'Kunne ikke laste ned mal',
    // Template content
    sheetName: 'Massebestilling',
    instructionsSheetName: 'Instruksjoner',
    columnDescriptions: 'Kolonnebeskrivelser:',
    columnHeader: 'Kolonne',
    columnRequired: 'Påkrevd',
    columnOptional: 'Valgfri',
    columnDescription: 'Beskrivelse',
    templateNotes: 'Notater:',
    templateNote1: 'Første rad må inneholde kolonneoverskrifter nøyaktig som vist',
    templateNote2: 'Data starter fra rad 2',
    templateNote3: 'SKU må samsvare med eksisterende produktkoder i systemet',
    templateNote4: 'Mengde må være et positivt heltall mellom 1 og 9999',
    templateNote5: 'Maksimalt 1000 rader tillatt per fil',
    templateNote6: 'Lagre som .xlsx- eller .csv-format',
    stockAvailabilityWarning: 'Faktisk lagertilgjengelighet vil bli sjekket på neste kasseside.',
    outOfStock: 'Utsolgt',
    insufficientStock: 'Utilstrekkelig lager: {available} tilgjengelig, {requested} forespurt',
  },
  orderExport: {
    export: 'Eksporter bestilling',
    exportOrder: 'Eksporter bestillingsdata',
    exportAsCSV: 'Eksporter som CSV',
    exportAsExcel: 'Eksporter som Excel',
    exportForReorder: 'Eksporter for masseimport',
    detailed: 'Fullstendige detaljer',
    simpleFormat: 'Importformat',
  },
};